import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Fade,
  IconButton,
  Button,
} from "@mui/material";
import ScreenRotationIcon from "@mui/icons-material/ScreenRotation";
import CloseIcon from "@mui/icons-material/Close";

const RotateScreen = ({openRotate, setOpenRotate}) => {

   
    const [dontShowAgain, setDontShowAgain] = useState(false);

    const handleCheckboxChange = (event) => {
    setDontShowAgain(event.target.checked);
  };

  const handleClose = () => {
    setOpenRotate(false);
  };

  const hanldeCloseButton = () => {
    if(dontShowAgain){
        localStorage.removeItem("screenRotate")
    }
    setOpenRotate(false);
  }
  return (
    <Modal open={openRotate} closeAfterTransition>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 24,
          p: 4,
          width: 280,
          textAlign: "center",
        }}
        
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 4,
            right: 8,
            color: "grey.600",
            marginBottom:"20px"
          }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{  
            display:"flex",
            alignItems:"center",
            gap:"10px"
        }}> 
          <ScreenRotationIcon
            sx={{
              fontSize: 35,
              animation: "rotatePhone 2s infinite ease-in-out",
              color: "primary.main",
            }}
          />
          <Typography variant="h6" mb={2} mt={1}>
            Rotate your screen for better view
          </Typography>
        </Box>

        <FormControlLabel
            sx={{
                display:"flex",
                justifyContent:"end"
            }}
          control={
            <Checkbox
              checked={dontShowAgain}
              onChange={handleCheckboxChange}
              sx={{
                color: "primary.main",
                "&.Mui-checked": {
                  color: "primary.main",
                },
               "& .MuiSvgIcon-root": {
                    fontSize: "22px", // Change this to whatever size you want
                    },
              }}
            />
          }
          label="Don't show this again"
        />

        <Box sx={{
            display:"flex",
            justifyContent:"end"
        }}>
            <Button
                variant="contained"
                sx={{
                    // width:"10px",
                    height:"30px",
                    mt:"20px"
                }}
                onClick={hanldeCloseButton}
            >ok</Button>
        </Box>

        <style>
          {`
              @keyframes rotatePhone {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(-45deg); }
                // 50% { transform: rotate(0deg); }
                // 75% { transform: rotate(-90deg); }
                // 100% { transform: rotate(0deg); }
              }
            `}
        </style>
      </Box>
    </Modal>
  );
}

export default RotateScreen